class FacebookLiveStatus {
  id: string;

  status: string;

  commentsCount: number;

  timestamp: Date;

  constructor({
    id,
    status,
    commentsCount,
    timestamp,
  }: {
    id: string;
    status: string;
    commentsCount: number;
    timestamp: Date;
  }) {
    this.id = id;
    this.status = status;
    this.commentsCount = commentsCount;
    this.timestamp = timestamp;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static fromApiResponse(columns: string[], rows: any[][]): FacebookLiveStatus[] {
    if (rows.length === 0) {
      return [];
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return rows.map((row: any[]) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const v: any = {};
      columns.forEach((column, index) => {
        const camelCaseKey = column.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
        if (row[index] && camelCaseKey === 'timestamp') {
          v[camelCaseKey] = new Date(row[index]);
        } else {
          v[camelCaseKey] = row[index];
        }
      });
      return new FacebookLiveStatus(v);
    });
  }
}

export default FacebookLiveStatus;
